import React from 'react';
import DirectionsBikeIcon from '@material-ui/icons/DirectionsBike';



function scrollFunction() {
    if (window.innerWidth > 1080){
      var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
      var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      var scrolled = (winScroll / height) * 100;
      if (document.getElementById("myBar") && document.getElementById("road")){
        document.getElementById("myBar").style.marginLeft = scrolled + "%";
        document.getElementById("road").style.width = 2+scrolled + "%";
      }
    //   let userAgentString = navigator.userAgent;
    //   let firefoxAgent = userAgentString.indexOf("Firefox") > -1;
    //   if (firefoxAgent){
    //       document.getElementById("myBar").style.display = "none";
    //       document.getElementById("road").style.display = "none";
    //   }
      if (document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {
          document.getElementById("header").style.fontSize = "18px";
          document.getElementById("header").style.height = "22vh";
          document.getElementById("header").style.position = "fixed";
          document.getElementById("header").style.zIndex = "200";
          document.getElementById("header").style.top = 0;
          document.getElementById("header").style.opacity = "75%";
          document.getElementById("spare").style.height = "30vh";
        }
        else if (document.body.scrollTop === 0 || document.documentElement.scrollTop === 0){
          document.getElementById("header").style.fontSize = "30px";
          document.getElementById("header").style.height = "30vh"
          document.getElementById("header").style.zIndex = "50";
          document.getElementById("header").style.position = "static";
          document.getElementById("header").style.opacity = "100%";
          document.getElementById("spare").style.height = "0px";
        }
         else {
          document.getElementById("header").style.fontSize = "30px";
          document.getElementById("header").style.height = "30vh"
          document.getElementById("spare").style.height = "0px";
        }
    }

    else if (window.innerWidth > 600){
        var winScroll2 = document.body.scrollTop || document.documentElement.scrollTop;
        var height2 = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        var scrolled2 = (winScroll2 / height2) * 100;
        if (document.getElementById("myBar") && document.getElementById("road")){
            document.getElementById("myBar").style.marginLeft = scrolled2 + "%";
            document.getElementById("road").style.width = 2+scrolled2 + "%";
        }
        //   let userAgentString = navigator.userAgent;
        //   let firefoxAgent = userAgentString.indexOf("Firefox") > -1;
        //   if (firefoxAgent){
        //       document.getElementById("myBar").style.display = "none";
        //       document.getElementById("road").style.display = "none";
        //   }
        if (document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {
            document.getElementById("header").style.fontSize = "9px";
            document.getElementById("notation").style.fontSize = "9px";
            document.getElementById("header").style.height = "17vh";
            document.getElementById("header").style.position = "fixed";
            document.getElementById("header").style.zIndex = "200";
            document.getElementById("header").style.top = 0;
            document.getElementById("header").style.opacity = "75%";
            document.getElementById("spare").style.height = "30vh";
            }
            else if (document.body.scrollTop === 0 || document.documentElement.scrollTop === 0){
            document.getElementById("header").style.fontSize = "20px";
            document.getElementById("notation").style.fontSize = "10px";
            document.getElementById("header").style.height = "23vh"
            document.getElementById("header").style.zIndex = "50";
            document.getElementById("header").style.position = "static";
            document.getElementById("header").style.opacity = "100%";
            document.getElementById("spare").style.height = "0px";
            }
            else {
            document.getElementById("header").style.fontSize = "20px";
            document.getElementById("notation").style.fontSize = "10px";
            document.getElementById("header").style.height = "23vh"
            document.getElementById("spare").style.height = "0px";
        }
    }

    else if (window.innerWidth > 400){
        var winScroll3 = document.body.scrollTop || document.documentElement.scrollTop;
        var height3 = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        var scrolled3 = (winScroll3 / height3) * 100;
        if (document.getElementById("myBar") && document.getElementById("road")){
            document.getElementById("myBar").style.marginLeft = scrolled3 + "%";
            document.getElementById("road").style.width = 2+scrolled3 + "%";
        }
        //   let userAgentString = navigator.userAgent;
        //   let firefoxAgent = userAgentString.indexOf("Firefox") > -1;
        //   if (firefoxAgent){
        //       document.getElementById("myBar").style.display = "none";
        //       document.getElementById("road").style.display = "none";
        //   }
        if (document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {
            document.getElementById("header").style.fontSize = "8px";
            document.getElementById("notation").style.fontSize = "5px";
            document.getElementById("header").style.height = "19vh";
            document.getElementById("header").style.position = "fixed";
            document.getElementById("header").style.zIndex = "200";
            document.getElementById("header").style.top = 0;
            document.getElementById("header").style.opacity = "75%";
            document.getElementById("spare").style.height = "30vh";
            }
            else if (document.body.scrollTop === 0 || document.documentElement.scrollTop === 0){
            document.getElementById("header").style.fontSize = "14px";
            document.getElementById("notation").style.fontSize = "9px";
            document.getElementById("header").style.height = "20vh"
            document.getElementById("header").style.zIndex = "50";
            document.getElementById("header").style.position = "static";
            document.getElementById("header").style.opacity = "100%";
            document.getElementById("spare").style.height = "0px";
            }
            else {
            document.getElementById("header").style.fontSize = "14px";
            document.getElementById("notation").style.fontSize = "9px";
            document.getElementById("header").style.height = "20vh"
            document.getElementById("spare").style.height = "0px";
        }
    }
  }

//   let userAgentString = navigator.userAgent;
//   let firefoxAgent = userAgentString.indexOf("Firefox") > -1;




class Header extends React.Component {

    

    componentDidMount(){
        
        window.onscroll = function() {scrollFunction()};
    }

    render(){
        return (
            <div id="header">
                <div id="headerborder">
                    <div id="hcon" style={{"width": "100%", "textAlign": "center"}}>
                        <h1 style={{"fontFamily": "PhotographSignature","paddingBottom": "2px", "textAlign": "center"}}>Himanshu Mahawar Photography</h1>
                        <p id="notation">Capturing Emotions</p>
                    </div>
                </div>
                <div className="progress-container" style={{"paddingTop": "5px", "paddingBottom": "5px"}}>
                    <div className="progress-bar" id="myBar">
                        <DirectionsBikeIcon />
                    </div>
                    <div id="road"></div>
                </div>
            </div>
        );
    }
}

export default Header;